import { cycleCountRuleDataSchema } from "@redotech/redo-inventory-common/cycle-counts";
import {
  cycleCountRuleIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const upsertCycleCountRule = unaryRpc({
  name: "upsertCycleCountRule" as const,
  input: z.object({
    id: cycleCountRuleIdFormat.schema.nullable(),
    name: z.string().min(1).max(200),
    description: z.string().nullable(),
    status: z.enum(["live", "disabled", "draft"]),
    dueDaysAfterCreation: z.int().min(1).max(365),
    locationId: locationIdFormat.schema,
    assignedRole: z.string().nullable().optional(),
    assignedUserId: z.string().nullable().optional(),
    typed: cycleCountRuleDataSchema,
    liveAt: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .nullable()
      .optional(),
  }),
  output: z.object({ id: cycleCountRuleIdFormat.schema }),
});
